(() => {
  const root = document.querySelector('.urmark-all-catalog:not([hidden])');
  if (!root) return;

  const navItems = Array.from(root.querySelectorAll('.urmark-all-catalog__nav-item'));
  const sections = Array.from(root.querySelectorAll('[data-catalog-section]'));
  if (!navItems.length || !sections.length) return;

  const setActive = (id) => {
    navItems.forEach((item) => {
      item.classList.toggle('is-active', item.dataset.target === id);
    });
  };

  navItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      const target = document.getElementById(item.dataset.target);
      if (!target) return;
      event.preventDefault();
      setActive(target.id);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

    if (visible) setActive(visible.target.id);
  }, {
    root: null,
    rootMargin: '-18% 0px -62% 0px',
    threshold: [0, 0.15, 0.35, 0.6]
  });

  sections.forEach((section) => observer.observe(section));
})();